import {Dispatch, useEffect, useState} from 'react';
import STORAGE from '../enum/Storage';
import useCookie from 'react-use/lib/useCookie';

export interface TokenHandlerCookies {
    auftragsId: string;
    zahlungToken: string;
    csrfToken: string | null;
    expiresIn: string | null;
    deleteCsrfToken: Dispatch<void>;
    deleteExpiresIn: Dispatch<void>;
    deleteTransactionCookie: Dispatch<void>;
}

export function useTokenHandlerCookies(): TokenHandlerCookies {
    const [csrfToken, , deleteCsrfToken] = useCookie(STORAGE.CSRF);
    const [expiresIn, , deleteExpiresIn] = useCookie(STORAGE.EXPIRES_IN);
    const [transactionCookie, , deleteTransactionCookie] = useCookie(STORAGE.TRANSACTION)
    const [auftragsId, setAuftragsId] = useState<string>('');
    const [zahlungToken, setZahlungToken] = useState<string>('');

    useEffect(() => {
        if (transactionCookie && !auftragsId) {
            setAuftragsId(transactionCookie?.split(':')?.[0] || '');
            setZahlungToken(transactionCookie?.split(':')?.[1] || '')
        }
    }, [transactionCookie, auftragsId])

    return {
        auftragsId,
        zahlungToken,
        csrfToken,
        expiresIn,
        deleteCsrfToken,
        deleteExpiresIn,
        deleteTransactionCookie,
    };
}
